import { type FC } from 'react';

import { Divider } from '@vakantiesnl/components/src/atoms/Divider';
import { type Booking, type MicroCopy, type Search } from '@vakantiesnl/types';

import { useStyles } from './FlightsOverview.styles';
import { useBreakpoints } from '../../utils/useBreakpoints';
import { FlightWithStopOver } from '../Flight/FlightWithStopOver';

export type FlightSelectorProps = {
	inbound: Search.Flight | Booking.Flight;
	outbound: Search.Flight | Booking.Flight;
	microCopy: MicroCopy;
	hasToggleStopOver?: boolean;
};

export const FlightsOverview: FC<FlightSelectorProps> = (props) => {
	const { inbound, microCopy, outbound, hasToggleStopOver } = props;
	const { classes } = useStyles();
	const { isMobile } = useBreakpoints();

	return (
		<div className={classes.flightsContainer} data-cy="flights-overview">
			<div className={classes.flights}>
				<div>
					<FlightWithStopOver
						flight={outbound}
						microCopies={microCopy}
						isOutbound={true}
						hasToggleStopOver={hasToggleStopOver}
						showLeadingAirPlaneIcons
						showTitle
					/>
				</div>
				{isMobile && <Divider noMargins />}
				<div>
					<FlightWithStopOver
						flight={inbound}
						microCopies={microCopy}
						isOutbound={false}
						hasToggleStopOver={hasToggleStopOver}
						showLeadingAirPlaneIcons
						showTitle
					/>
				</div>
			</div>
		</div>
	);
};
